var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { combinedCss } from './styles';
var StyledH1 = styled.h1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), combinedCss(p)); });
var StyledH2 = styled.h2(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) { return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), combinedCss(p)); });
var StyledH3 = styled.h3(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) { return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), combinedCss(p)); });
var StyledH4 = styled.h4(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) { return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), combinedCss(p)); });
var StyledH5 = styled.h5(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) { return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), combinedCss(p)); });
var StyledH6 = styled.h6(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) { return css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), combinedCss(p)); });
export var Title = function (_a) {
    var children = _a.children, tag = _a.tag, props = __rest(_a, ["children", "tag"]);
    var TitleTag;
    switch (tag) {
        case 'h1':
            TitleTag = StyledH1;
            break;
        case 'h2':
            TitleTag = StyledH2;
            break;
        case 'h3':
            TitleTag = StyledH3;
            break;
        case 'h4':
            TitleTag = StyledH4;
            break;
        case 'h5':
            TitleTag = StyledH5;
            break;
        case 'h6':
            TitleTag = StyledH6;
            break;
    }
    return _jsx(TitleTag, __assign({}, props, { children: children }), void 0);
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
//# sourceMappingURL=Title.js.map